import {BaseEvent} from "./BaseEvent";

export class EditDashboardEvent extends BaseEvent {
  public static NAME = 'editDashboard';

  constructor() {
    super(EditDashboardEvent.NAME);
  }
}
